import { createSlice } from "@reduxjs/toolkit";
import { ACTIVE_TAB } from "configs/constants";

const initialState = {
  activeTab: ACTIVE_TAB.ALL,
  searchKeyword: "",
  selectedFlightDetails: null,
  visitedForFirstTime: true,
  lastSelectedFlightItem: {
    id: null,
    scrolledAmountInList: null,
  },
  smartGateBannerVisible: true,
};

export const flightsListSlice = createSlice({
  name: "flightsList",
  initialState,
  reducers: {
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload;
    },
    setSearchKeyword: (state, { payload }) => {
      state.searchKeyword = payload;
    },
    setSelectedFlightDetails: (state, { payload }) => {
      state.selectedFlightDetails = payload;
    },
    setVisitedForFirstTime: (state, { payload }) => {
      state.visitedForFirstTime = payload;
    },
    setLastSelectedFlightItem: (state, { payload }) => {
      state.lastSelectedFlightItem = payload;
    },
    resetLastSelectedFlightItem: (state) => {
      state.lastSelectedFlightItem = {
        id: null,
        scrolledAmountInList: null,
      };
    },
    triggerScrollToTop: (state, { payload }) => {
      state.lastSelectedFlightItem = {
        ...state.lastSelectedFlightItem,
        scrolledAmountInList: payload,
      };
    },
    setSmartGateBannerVisible: (state, { payload }) => {
      state.smartGateBannerVisible = payload;
    },
  },
});

export const {
  setActiveTab,
  setSearchKeyword,
  setSelectedFlightDetails,
  setLastSelectedFlightItem,
  triggerScrollToTop,
  setVisitedForFirstTime,
  resetLastSelectedFlightItem,
  setCategory,
  setSmartGateBannerVisible,
} = flightsListSlice.actions;

export const flightsListSelector = (state) => state.flightsList;

export default flightsListSlice.reducer;
